import type { UserAvatar } from '../../api/people';
import { uiText } from '../../i18n';
import { studioApi, type StudioApp } from '../studio/studio-api';
import { useStudioDocument } from '../studio/use-studio-document';
import { MotionOrderForm } from './MotionOrderForm';
import { motionEntryChars, motionEntryInputs, motionPolicy } from './motion-model';
import { StudioZero } from '../studio/StudioZero';
export function MotionEntryForm(props: { app: StudioApp; avatar: UserAvatar | null; initialInputs?: Record<string, unknown> }) {
  const probe = useStudioDocument(s => studioApi.form(props.app.id, s), `motion-entry:${props.app.id}`);
  if (probe.loading) return <p role="status">{uiText('Загружаем…')}</p>;
  /* Форму не получили — оформленная сцена, а не строка текста: иначе на весь экран создания
     висела одна строка «Создание сейчас недоступно Повторить» (как было и у текстового экрана). */
  if (probe.error || !probe.data || probe.data.app_id !== props.app.id || !['dance', 'swap'].includes(probe.data.screen))
    return (
      <StudioZero
        title="Создание сейчас недоступно"
        text={uiText('Попробуйте ещё раз или вернитесь к шаблонам.')}
        action={{ label: 'Повторить', icon: 'arrow', onClick: probe.reload }}
      />
    );
  /* Вход экрана (07-apps.md §10: who, char, chars, pid, voice, bg) переводится в опубликованные поля формы; пустой вход — черновик. */
  const mapped = motionEntryInputs(probe.data, props.initialInputs);
  return motionPolicy(probe.data) ? (
    <MotionOrderForm
      {...props}
      initialInputs={Object.keys(mapped).length ? mapped : undefined}
      firstChars={motionEntryChars(props.initialInputs)}
    />
  ) : (
    <StudioZero title="Создание сейчас недоступно" text={uiText('Выберите другой инструмент или вернитесь к шаблонам.')} />
  );
}
